import { render, staticRenderFns } from "./AdminResultsIndividuelsPopupDetails.vue?vue&type=template&id=370eb7e4&scoped=true&"
import script from "./AdminResultsIndividuelsPopupDetails.vue?vue&type=script&lang=js&"
export * from "./AdminResultsIndividuelsPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminResultsIndividuelsPopupDetails.vue?vue&type=style&index=0&id=370eb7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370eb7e4",
  null
  
)

export default component.exports